const RpcNonReportTypes = {
  //*************RPC NON REPORT LIST DETAILS START******************/
  RPC_NON_REPORT_LIST_START: "rpc_non_report_list_start",
  RPC_NON_REPORT_LIST_SUCCESS: "rpc_non_report_list_success",
  RPC_NON_REPORT_LIST_FAILURE: "rpc_non_report_list_failure",
  RPC_NON_REPORT_LIST_RESET_START: "rpc_non_report_list_reset_start",
  RPC_NON_REPORT_LIST_CHANGED: "rpc_non_report_changed",
  //*************RPC NON REPORT LIST DETAILS END******************/

  //*****************RPC NON REPORT CAMPAIGN DETAILS START*****************/
  RPC_NON_REPORT_CAMPAIGN_START: "rpc_non_report_campaign_start",
  RPC_NON_REPORT_CAMPAIGN_SUCCESS: "rpc_non_report_campaign_success",
  RPC_NON_REPORT_CAMPAIGN_FAILURE: "rpc_non_report_campaign_failure",
  RPC_NON_REPORT_CAMPAIGN_RESET_START: "rpc_non_report_campaign_reset_start",
  RPC_NON_REPORT_CAMPAIGN_CHANGED: "rpc_non_report_campaign_changed",
  //*****************RPC NON REPORT CAMPAIGN DETAILS END *****************/

  //******************RPC NON REPORT EXPORT DETAILS START******************/
  RPC_NON_REPORT_EXPORT_START: "rpc_non_report_export_start",
  RPC_NON_REPORT_EXPORT_SUCCESS: "rpc_non_report_export_success",
  RPC_NON_REPORT_EXPORT_FAILURE: "rpc_non_report_export_failure",
  RPC_NON_REPORT_EXPORT_RESET_START: "rpc_non_report_export_reset_start",
  RPC_NON_REPORT_EXPORT_CHANGED: "rpc_non_report_export_changed",
  //******************RPC NON REPORT EXPORT DETAILS START******************/
};
export default RpcNonReportTypes;
